class DoughMixesDiscount extends HTMLElement {
  connectedCallback() {
    onLibReady(['vue'], this.#init.bind(this));
  }

  async #init() {
    const apiUrl = 'https://test1.allix.website/DriveBase/hs/ITrade';
    const fetchHeaders = {
      'Content-Type': 'application/json',
      Authorization: 'Basic d3NVc2VyMTU0NTpET3dnbVQ5MDEyNTRQa0ts',
    };

    const stepsDiv = this.querySelector('[data-steps]');
    const productsDiv = this.querySelector('[data-products]');

    new Vue({
      el: stepsDiv,
      data: {
        step: 1,
        loading: false,
        error: null,
        mixCode: null,
        email: null,
        token: uuidv4(),
        productsShow: false,
        productSubscriptionShow: false,
        discounts: null,
      },
      template: `
        <div class="page-width" >
          <div class="dough-mixes-discount">
            <form method="post" action="/contact" id="contact_form" accept-charset="UTF-8" class="contact-form">
              <input type="hidden" name="form_type" value="contact">
              <input type="hidden" name="utf8" value="✓">
              <input type="hidden" name="contact[Theme]" :value="step === 0 ? 'Mix code not founded' : 'Mix code'">
                  
              <template v-if="step === 0">
                <div class="dough-mixes-discount__step dough-mixes-discount__step-error" >
                  <p class="dough-mixes-discount__step-title">
                    Oops, it seems there was an issue
                  </p>  
                  
                  <p class="dough-mixes-discount__step-content">
                    Please try using a different mix code or contact us by sending an email to <a href="mailto:support@aldkitchen.com">support@aldkitchen.com</a> and include a picture of the voucher for further assistance 
                  </p>
                  
                  <input type="hidden" name="contact[mixCode]" :value="mixCode">
                  
                  <div class="form-group large center">
                    <button class="button button--large button--orange" :class="{loading}" aria-label="Try another code">Try another code</button>
                  </div>
                </div>
              </template>   
              
              <template v-else>              
                <div class="dough-mixes-discount__step dough-mixes-discount__step-code" v-if="step === 1 && !getQueryParams('code')">
                  <p class="dough-mixes-discount__step-title">
                    Welcome to our exciting new promotion!
                  </p>  
                  
                  <div class="form-group center">
                    <p class="dough-mixes-discount__step-title">Please input the Mix code</p>
                    <p class="dough-mixes-discount__step-content">Enter the exclusive Mix code located on the back of your postcard</p>
                  </div>
                
                  <div class="form-group large">
                      <div class="pin-input-fields-container" ref="pinInputFields">
                        <input type="text" pattern="[0-9]*" class="form-control" maxlength="1" required data-index="0">
                        <input type="text" pattern="[0-9]*" class="form-control" maxlength="1" required data-index="1">
                        <input type="text" pattern="[0-9]*" class="form-control" maxlength="1" required data-index="2">
                        <div class="separator" />
                        <input type="text" pattern="[0-9]*" class="form-control" maxlength="1" required data-index="3">
                        <input type="text" pattern="[0-9]*" class="form-control" maxlength="1" required data-index="4">
                        <input type="text" pattern="[0-9]*" class="form-control" maxlength="1" required data-index="5">
                      </div>
                  </div>
              
                  <div class="form-group large center">
                    <button class="button button--large button--orange" :class="{loading}" @click.prevent="submitMixCode" aria-label="Submit">Submit</button>
                  </div>
                </div>
                
                <div class="dough-mixes-discount__step dough-mixes-discount__step-email" v-if="step === 2">
                  <div>
                    <p class="dough-mixes-discount__step-sub-title">
                      Welcome to our exciting new promotion!
                    </p> 
                  </div>
                  
                  <div class="form-group center">
                    <p class="dough-mixes-discount__step-title">You mix-code is</p>
                    <p class="dough-mixes-discount__step-title dough-mixes-discount__step-title-code">{{mixCode?.toString().replace(/(\\d{3})(\\d{3})/, '$1-$2')}}</p>
                  </div>
                  
                  <div class="form-group center">
                    <p class="dough-mixes-discount__step-title">Please provide your Email</p>
                    <p class="dough-mixes-discount__step-content">We may use it to confirm your delivery address</p>
                  </div>
                
                  <div class="form-group large">
                    <input
                        class="form-control"
                        type="email"
                        name="email"
                        v-model="email"
                        placeholder="name@mail.com"
                    >
                  </div>
              
                  <div class="form-group large center">
                    <button class="button button--large button--orange" :class="{loading}" @click.prevent="submitEmail" aria-label="Submit">Submit</button>
                  </div>
                </div>
                
                <div class="dough-mixes-discount__step dough-mixes-discount__step-products" v-if="step === 3">
                  <div class="dough-mixes-discount__step-heading">
                    <p class="dough-mixes-discount__step-title">You're Qualified!</p>
                    <p class="dough-mixes-discount__step-content">Get a Personal Discount on Your Purchase or Mix Subscription Within the Next 12 Hours</p>
            
                    <ul class="tabs">
                      <li :class="{active: !productSubscriptionShow}" @click="productSubscriptionShow = false">
                        <span>One time Purchase</span>
                      </li>
            
                      <li :class="{active: productSubscriptionShow}" @click="productSubscriptionShow = true">
                        <span>Subscription</span>
                      </li>
                    </ul>
                  </div>
                </div>
                
                <div class="center" v-if="error">
                  <div class="alert-error" v-html="error" />
                </div>
              </template>    
            </form>
          </div>  
        </div>
      `,

      beforeMount() {
        if (getQueryParams('code')) {
          this.mixCode = getQueryParams('code');
          this.submitMixCode();
        }
      },

      async mounted() {
        if (this.$refs.pinInputFields) {
          const nums = this.$refs.pinInputFields.querySelectorAll('input');

          nums.forEach(num => {
            num.addEventListener('keyup', () => {
              let code = '';

              if (num.value === '' || /^\d+$/.test(num.value)) {
                if (num.value.length === 1) {
                  nums[parseInt(num.dataset.index) + 1]?.focus();
                } else {
                  nums[parseInt(num.dataset.index) - 1]?.focus();
                }
              } else {
                num.value = '';
              }

              nums.forEach(num => {
                code += num.value;
              });

              this.mixCode = code;
            });
          });
        }
      },

      watch: {
        productsShow: val => {
          productsDiv.style.display = val ? 'block' : 'none';
        },

        productSubscriptionShow: val => {
          const productSubscriptionDivs = this.querySelectorAll('[data-product-subscription]');
          const productPriceDivs = this.querySelectorAll('[data-product-price]');

          productSubscriptionDivs.forEach(div => {
            div.style.display = val ? 'block' : 'none';
            if (!val) {
              div.querySelector('input[name="paywhirl-plan-selector-group"][value=""]')?.click();
            }
          });

          productPriceDivs.forEach(div => {
            div.style.display = val ? 'none' : 'block';
          });
        },
      },

      methods: {
        nextStep() {
          setTimeout(() => {
            window.scrollTo({
              top: 0,
              behavior: 'smooth',
            });
          });

          this.step++;
        },

        async submitMixCode() {
          if (!this.mixCode) {
            this.setError('Enter promo code!');
            return;
          }

          this.clearError();

          const isValid = await this.checkCode();

          if (isValid) {
            this.nextStep();
          } else {
            this.handleInvalidCodeMessage();
          }
        },

        async submitEmail() {
          this.clearError();

          if (!this.isEmailValid()) {
            this.setError('Incorrect email!');
            return;
          }

          try {
            this.discounts = await this.createDiscount();

            if (!this.discounts) {
              throw new Error('Error when creating a discount!');
            }

            const response = await this.updateData();

            if (!response?.Succeed) {
              throw new Error('Server error!');
            }

            await this.applyDiscount();

            this.nextStep();
            this.productsShow = true;
          } catch (error) {
            this.setError(error.message || 'An unexpected error occurred!');
          }
        },

        async applyDiscount() {
          this.setLoading(true);
          await Shopify.discount.apply([this.discounts.code, this.discounts.codeSubsctiption]);
          this.setLoading(false);
        },

        handleInvalidCodeMessage() {
          const formattedCode = this.formatMixCode();
          this.error = `
            <p style="color: orange">We're sorry, but it seems the mix code ${formattedCode} is either not found or has expired.</p>
            <p style="color: orange">Please reach out to us at <a href="mailto:support@aldkitchen.com" style="color: blue; text-decoration: underline !important;">support@aldkitchen.com</a> to resolve this issue.</p>
          `;
        },

        formatMixCode() {
          return this.mixCode.toString().replace(/(\d{3})(\d{3})/, '$1-$2');
        },

        async checkCode() {
          this.setLoading(true);

          try {
            const response = await fetch(`${apiUrl}/CheckCode?Promocode=${this.mixCode}`, {headers: fetchHeaders});
            const data = await response.json();
            return data?.Accepted || false;
          } catch (error) {
            console.error('Error checking code:', error);
            return false;
          } finally {
            this.setLoading(false);
          }
        },

        async updateData() {
          this.setLoading(true);
          const url = `${apiUrl}/SetPromoData?Promocode=${this.mixCode}&Token=${this.token}&Email=${this.email}&Discount=${this.discounts.code}$DiscountSubscription=${this.discounts.codeSubsctiption}`;

          try {
            const response = await fetch(url, {headers: fetchHeaders});
            return await response.json();
          } catch (error) {
            return {errors: 'An error has occurred!'};
          } finally {
            this.setLoading(false);
          }
        },

        async createDiscount() {
          this.setLoading(true);
          const url = 'https://ald-custom.digitaluniverse.app/api/create-discount';

          try {
            const response = await fetch(url, {
              method: 'POST',
              headers: {
                'X-Shopify-Shop-Domain': Shopify.shop,
                'X-AC-Code': btoa(this.mixCode),
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({code: this.mixCode}),
              signal: AbortSignal.timeout(3000),
            });

            const data = await response.json();
            return data;
          } catch (error) {
            console.error('Discount creation error:', error);
            return null;
          } finally {
            this.setLoading(false);
          }
        },

        setLoading(isLoading) {
          this.loading = isLoading;
        },

        clearError() {
          this.error = '';
        },

        setError(message) {
          this.error = message;
        },

        isEmailValid() {
          return this.validateEmail(this.email);
        },

        validateEmail(email) {
          return /^[\w-+\.]+@([\w-]+\.)+[\w-]{2,4}$/.test(email);
        },
      },
    });
  }
}

customElements.define('dough-mixes-discount', DoughMixesDiscount);
